import { render } from "./ViewsDetailsComponent.vue?vue&type=template&id=474b4c44&scoped=true"
import script from "./ViewsDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ViewsDetailsComponent.vue?vue&type=script&lang=js"

import "./ViewsDetailsComponent.vue?vue&type=style&index=0&id=474b4c44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474b4c44"]])

export default __exports__